import { defineStore } from 'pinia';
import type { SlopeData } from '~/types/smcTypes';

export const useSlopeStore = defineStore('slope', () => {
    const slopes = ref<SlopeData[]>([]);
    const slopeTotal = ref(0);
    const token = useCookie<string>('token');

    const getSlopes = computed(() => slopes.value);
    const getSlopeTotal = computed(() => slopeTotal.value);

    async function fetchSlopesAll(params: { page?: number, limit?: number, name?: string }) {
        const response = await $fetch.raw(`/api/v1/user/slopes`, {
            params: {
                page: params.page,
                limit: params.limit,
                name: params.name
            },
            headers: {
                Authorization: `Bearer ${token.value}`
            }
        })

        slopes.value = response._data as any;
        slopeTotal.value = parseInt(response.headers.get('X-Total-Items') || '');
        // slopes.value = response._data as SlopeData[];
        // slopeTotal.value = Number(response.headers.get('x-pagination-total') ?? 0);
    }

    async function fetchSlope(slopeId: string) {
        const response = await $fetch.raw(`/api/v1/user/slopes/${slopeId}`, {
            headers: {
                Authorization: `Bearer ${token.value}`,
            },
        });
        return response._data as any;
    }

    async function createSlope(slope: SlopeData) {
        const response = await $fetch('/api/v1/user/slopes', {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token.value}`
            },
            body: slope
        });
        slopes.value.push(response as any);
        slopeTotal.value += 1;
    };

    async function updateSlope(slopeId: string, payload: any) {
        const response = await $fetch(`/api/v1/user/slopes/${slopeId}`, {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token.value}`
            },
            body: payload
        });
        return response
    };

    async function deleteSlope(slopeId: string) {
        await $fetch(`/api/v1/user/slopes/${slopeId}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token.value}`
            },
        });
        slopes.value = slopes.value.filter(slope => slope?.id !== slopeId);
        slopeTotal.value -= 1;
    };

    return {
        getSlopes,
        getSlopeTotal,
        fetchSlopesAll,
        fetchSlope,
        createSlope,
        updateSlope,
        deleteSlope
    }

})